import Constants from '../constants';
import produce from "immer";
import { UpdateArray,UpdateArrayRange } from '../misc/ArrayFuncs';
const initDataState = [];
const GlueRolls = (state = initDataState, action) => {
    switch (action.type) {
        case Constants.Actions.GlueRoll.Add:
            return UpdateArray(action.payload, state);
        case Constants.Actions.GlueRoll.Add_Rollback:
            const grID = state.findIndex(gr => gr.id === action.meta.newGR.id);
            if (grID !== -1) {
                return produce(state, pd => { pd.splice(grID, 1) });
            } else {
                return state;
            }
        case Constants.Actions.GlueRoll.Add_Commit:
            return UpdateArray(action.payload?.data, state);
        case Constants.Actions.GlueRoll.GetByID:
            return UpdateArray(action.data, state);
        case Constants.Actions.GlueRoll.Update:
            //Action will have the full plant data
            return state.map((p, ind) => {
                if (p.id === action.payload.id) {
                    return produce(p, pd => { pd[action.payload.name] = action.payload.newValue });
                } else { return p; }
            });
        case Constants.Actions.GlueRoll.Update_Commit:
            return UpdateArray(action.payload?.data, state);
        case Constants.Actions.GlueRoll.Update_Rollback:
            //Action will have the full plant data
            return state.map((p, ind) => {
                if (p.id === action.meta.updatePayload.id) {
                    return produce(p, pd => { pd[action.meta.updatePayload.name] = action.meta.updatePayload.oldValue });
                } else { return p; }
            });
        case Constants.Actions.GlueRoll.Delete:
            return UpdateArray(produce(action.payload, d => {
                d.deleted = true;
            }), state);
        case Constants.Actions.IngredientVerification_Delete_Commit:
            return state;
        case Constants.Actions.GlueRoll.Delete_Rollback:
            return UpdateArray(action.meta.delGR, state);
        case Constants.Actions.GlueRoll.ClearData:
            return initDataState;
        case Constants.Actions.GlueRoll.GetByVisitID:
            return UpdateArrayRange(action.data, state);
        default:
            return state;
    }
}
export default GlueRolls;